import { render, staticRenderFns } from "./GlobalNotifier.vue?vue&type=template&id=93e91280&scoped=true&"
import script from "./GlobalNotifier.vue?vue&type=script&lang=ts&"
export * from "./GlobalNotifier.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalNotifier.vue?vue&type=style&index=0&id=93e91280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e91280",
  null
  
)

export default component.exports